import { useState } from "react";
import { useIsomorphicLayoutEffect } from "usehooks-ts";

import useComponentWidth from "./useComponentWidth";

export default function useComputedCSSGridColumns(deps) {
  const [width, ref] = useComponentWidth();
  const [columns, setColumns] = useState();
  useIsomorphicLayoutEffect(() => {
    if (
      typeof window === "undefined" ||
      !window.getComputedStyle ||
      !ref.current
    ) {
      return;
    }
    let { gridTemplateColumns } = window.getComputedStyle(ref.current);
    setColumns(
      gridTemplateColumns.split(/\s+/g).map((width) => ({
        width: parseFloat(width),
      })),
    );
  }, [width, ref.current, ...deps]);
  return [columns, ref];
}
